<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <div class="dateboard">
      <div class="wrap">
        <div class="item">
          <div class="label">待结维修费：</div>
          <div class="value">{{ num1 }}</div>
        </div>
        <div class="item item01">
          <div class="label">累计维修费：</div>
          <div class="value">{{ num2 }}</div>
        </div>
      </div>
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item v-if="!hideAddBtn" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'560px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onChange="onModalChange" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      hideAddBtn: false,
      baseUrl: 'repair',
      getListUrl: 'reunitpayrec',
      breadcrumb: [
        { name: "维保管理", path: `/fix/repairer` },
        { name: "维修商管理", path: `/fix/repairer` },
        { name: "打款记录" },
      ],
      num1: 0,
      num2: 0,
      formCtrl: [
        {
          ...this.ctrls.month,
          label: "打款日期：",
          keyName: "time",
        },
      ],
      cols: [
        { prop: "maunit", label: "维修商名称" },
        { prop: "money", label: "打款金额", minwidth: 300 },
        { prop: "time", label: "打款日期" },
        { prop: "text", label: "备注", minwidth: 120 },
      ],
      getTotalProperty: ["paymoney"],
      btns: [
        {
          ...this.viewBtn,
          title: "打款记录",
          cb: ({ maunit, money, time, photo, text }) => {
            // console.log(id)
            this.title = '查看打款记录'
            this.viewMode = true
            this.mform = { name: maunit, money, time, photo, text }
            // console.log({ ...this.mform })
            this.showDialog()
          },
        },
      ],
      title: '查看打款记录',
      mform: {},
      mrules: {
        money: [
          {
            required: true,
            message: '请填写打款金额',
            trigger: 'blur',
          }
        ],
        time: [
          {
            required: true,
            message: '请选择打款日期',
            trigger: 'blur',
          }
        ],
        photo: [
          {
            required: true,
            message: '请上传打款凭证',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "维修商名称",
          keyName: "name",
          type: "text",
          disabled: true,
        },
        {
          label: "打款金额",
          keyName: "money",
          err: "请填写打款金额",
          type: "number",
        },
        {
          label: "打款日期",
          keyName: "time",
          err: "请选择打款日期",
          type: "date",
        },
        {
          label: "打款凭证",
          keyName: "photo",
          tips: "最多上传2张图片",
          type: "file",
          ptype: "payment",
          max: 2,
        },
        {
          label: "备注",
          keyName: "text",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
          
        },
      ],
      modalSubmitUrl: 'addreunitpay',
      viewMode: false,
      baseParams: ['shipperid'],
    };
  },
  methods: {
    addItem() {
      this.title = '添加打款记录'
      this.viewMode = false
      const { name, reunitid } = this.mform
      this.mform = {
        name,
        reunitid,
        money: '',
        time: '',
        photo: null,
        text: '',
      }
      console.log({ ...this.mform })
      this.showDialog()
    },
    tableDataHandler(res) {
      if (typeof res === 'string') {
        this.$message({
          type: 'error',
          message: res
        });
      } else {
        const { count, data, accumulate, unsettled } = res
        this.total = count
        this.num1 = unsettled
        this.num2 = accumulate
        if (data && data.length) {
          // console.log(data)
          // this.tableData = [...data]
          this.tableData = data.map(v => {
            return this.dataObjHandler(v)
          })
          // this.setListHistory()
        }
      }
    },
  },
  mounted() {
    const { user_group_id, nickname } = this.user
    if (user_group_id == 16) {
      this.hideAddBtn = true
      this.mform.name = nickname
      this.mform.reunitid = this.user.id
      this.formInline['userid'] = this.user.id
      this.$nextTick(this.getList);
    } else {
      const { id, name } = this.$route.query
      this.mform.name = name
      this.mform.reunitid = id
      this.$forceUpdate()
      // console.log({ ...this.mform })
      this.formInline.id = id
      this.$nextTick(this.getList);
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  .el-form {
    .el-form-item {

      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100% !important;
      }
    }
  }

  .btns {
    .mians {
      text-align: center;
    }
  }
}

.main {
  /deep/ .fillet {
    box-shadow: none;
    border-radius: 0;
  }
}

.dateboard {
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  background: #fff;
  // border-radius: 5px 5px 0 0;
  overflow: hidden;

  .wrap {
    display: flex;
    align-items: center;
    padding: 20px;
    margin: 20px;
    background: #F7F7F7;
  }

  .item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #606266;

    &:not(:first-of-type) {
      margin-left: 100px;
    }

    .label {
      position: relative;
      padding-left: 36px;
      height: 25px;
      line-height: 25px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        background: #FFFFFF url(../../../assets/img/ico_payment_01.png) no-repeat center center;
        background-size: 11px;
      }

    }

    &.item01 {
      .label {

        &::before {
          background-image: url(../../../assets/img/ico_payment_02.png);
        }
      }
    }

    .value {
      height: 25px;
      line-height: 25px;
    }
  }
}
</style>
